export const GET_AUTH_CODE = 'GET_AUTH_CODE'
export const GET_AUTH_STATUS = 'GET_AUTH_STATUS'
export const GET_AUTH_URL = 'GET_AUTH_URL'
export const GET_IMANAGE_FILE_PICKER = 'GET_IMANAGE_FILE_PICKER'
export const GET_IMANAGE_FOLDER_PICKER = 'GET_IMANAGE_FOLDER_PICKER'
export const POST_FILDERS_TO_IMANAGE = 'POST_FILDERS_TO_IMANAGE'
export const START_AUTH_TIMER = 'START_AUTH_TIMER'
